import React from 'react';
import LeftSidebarProducts from './LeftSidebarProducts';
import LeftSidebarFooter from './LeftSidebarFooter';
import useWindowSize from '../hooks/useWindowSize';

 const LeftSidebar = ({ isExpanded, toggleExpanded, products }) => {
  const { width } = useWindowSize();

  if (!products || products.length === 0) return null;
  if (width < 1100 && !isExpanded) return null;

  return (
    <div className="sidebar small no-print" onClick={width < 1100 ? toggleExpanded : undefined}>
      <div className="sidebar-container">
        <div className="sidebar-top text-right">
          <span className="button transparent icon-close no-text gray-dark" />
        </div>
        <div className="sidebar-content">
          <LeftSidebarProducts items={products} mobile={width < 1100} isOpen={isExpanded} />
        </div>
        <LeftSidebarFooter toggle={toggleExpanded} isOpen={isExpanded} />
      </div>
    </div>
  );
};

export default LeftSidebar;
